import type { RootState } from 'js/src/libs/RootState';

export function getUsageLimits(state: RootState) {
    return state.usageLimit;
}

export function getAIVOMinutesLimit(state: RootState): number | null {
    return getUsageLimits(state)?.ai_vo_minutes_limit_per_cycle;
}

export function getAIVOMinutesUsedInCycle(state: RootState): number | undefined {
    return getUsageLimits(state)?.ai_vo_minutes_used_in_cycle;
}
